if (!customElements.get('rudca-desktop-gallery-zoom')) {
  customElements.define('rudca-desktop-gallery-zoom', class extends HTMLElement {
    connectedCallback() {
      this.gallery = this.closest('.product-gallery');
      this.dialog = this.querySelector('dialog');
      this.image = this.querySelector('.rudca-gallery-dialog__image');
      if (!this.gallery || !this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.desktop = window.matchMedia('(min-width: 1000px)');
      this.openImage = (event) => {
        const link = event.target.closest('.rudca-gallery-open');
        if (!link || event.defaultPrevented || !this.desktop.matches || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const source = link.parentElement.querySelector('.product-gallery__image');
        if (!source) return;
        event.preventDefault();
        this.opener = link;
        this.image.src = link.href;
        this.image.alt = source.alt;
        this.image.width = source.naturalWidth || 1600;
        this.image.height = source.naturalHeight || 1600;
        if (!this.dialog.open) this.dialog.showModal();
      };
      this.closeBackdrop = (event) => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      };
      this.restoreFocus = () => {
        if (this.desktop.matches && this.opener?.isConnected) this.opener.focus({ preventScroll: true });
      };
      this.handleResize = () => {
        if (!this.desktop.matches && this.dialog.open) this.dialog.close();
      };
      this.gallery.addEventListener('click', this.openImage);
      this.dialog.addEventListener('click', this.closeBackdrop);
      this.dialog.addEventListener('close', this.restoreFocus);
      this.desktop.addEventListener('change', this.handleResize);
      this.gallery.querySelectorAll('.rudca-gallery-open').forEach(link => link.setAttribute('aria-haspopup', 'dialog'));
    }

    disconnectedCallback() {
      this.gallery?.removeEventListener('click', this.openImage);
      this.dialog?.removeEventListener('click', this.closeBackdrop);
      this.dialog?.removeEventListener('close', this.restoreFocus);
      this.desktop?.removeEventListener('change', this.handleResize);
      if (this.dialog?.open) this.dialog.close();
    }
  });
}
